import { Table, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";
import { getAppointments, AppointmentItem } from "../../../api/Appointment";

export default function OrderList({ customerId }: { customerId?: number }) {
    const { t } = useTranslation();
    const [data, setData] = useState<AppointmentItem[]>([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });

    const fetchData = useCallback(async (page = 1) => {
        if (!customerId) return;
        setLoading(true);
        try {
            const res = await getAppointments({
                channel_customer_id: customerId,
                page,
                take: 5,
            });
            if (res.status) {
                setData(res.data?.items || []);
                setPagination(prev => ({
                    ...prev,
                    current: res.data?.current_page || 1,
                    total: res.data?.total || 0,
                }));
            }
        } finally {
            setLoading(false);
        }
    }, [customerId]);

    useEffect(() => {
        fetchData(1);
    }, [fetchData]);

    const columns = [
        {
            title: t("roomchat.order_id"),
            dataIndex: "code",
        },
        {
            title: t("roomchat.product_name"),
            render: (_: any, record: any) => {
                const services = record.services;
                if (services && services.length > 0) {
                    return (
                        <div className="max-h-[80px] overflow-y-auto">
                            {services.map((s: any, i: number) => (
                                <div key={s.id || i} className="truncate text-sm leading-5">{s.name}</div>
                            ))}
                        </div>
                    );
                }
                return record.service?.name || '—';
            },
            ellipsis: true,
            width: 180,
        },
        {
            title: t("roomchat.subtotal"),
            dataIndex: "amount",
            render: (v: number) => v ? `${v.toLocaleString()} đ` : '—',
        },
    ];

    return (
        <div className="space-y-2">
            <Spin spinning={loading}>
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    pagination={{
                        current: pagination.current,
                        total: pagination.total,
                        pageSize: pagination.pageSize,
                        onChange: (p) => fetchData(p),
                    }}
                    size="small"
                    className="custom-ant-table"
                    scroll={{ x: "max-content" }}
                />
            </Spin>
        </div>
    );
}